<template id="dialog">
  <div class="dialog" v-if="showDialog">
    <div class="dialog_mask"></div>
    <!-- <div class="dialog_container"> -->
    <div class="container">
      <div class="close" @click="closeDialog"></div>
      <div class="title">{{ this.dialogInfoData.title }}</div>
      <div class="dialog_tabs">
        <Menu mode="horizontal" :theme="'primary'" active-name="1" @on-select="menuSelect">
          <MenuItem name="1">
            <Icon type="ios-stats" />
            消杀曲线走势图
          </MenuItem>
          <MenuItem name="2">
            <Icon type="ios-stats" />
            二氧化碳曲线走势图
          </MenuItem>
        </Menu>
      </div>
      <div class="line_item">
        <div class="element_loading" v-show="toploading" v-loading="toploading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"  element-loading-background="rgba(0, 0, 0, 0.3)"></div>
        <div class="chartLine" ref="chartLineDom" style='width:100%;height:100%;'></div>
      </div>
      <div class="down_center">
            <div class="down_info">
              <h2 class="div_title1">用户基本信息</h2>
              <div class="down_li_item">
                <ol class="ol1">
                   <li v-for="(item, index) in this.deviceInfo" :key="index">
                     {{ item.value }}
                   </li>
                </ol>
              </div>
            </div>
            <div class="down_data">
              
              <h2 class="div_title2">空气质量监测</h2>
                 <div class="down_data_shidu">
                    <img class="divtit_img" src="../../../static/img/icon/shidu.png" />
                    <span class="span_key">{{shiduvalue}}</span>
                    <span style="top:10px;color:cornsilk">    %   </span>

                </div>
                <div class="down_data_temp">
                    <img class="divtit_img" src="../../../static/img/icon/temp.png" />
                    <span class="span_key">{{tempvalue}}</span>
                    <span style="top:10px;color:cornsilk">  ℃  </span>

                </div>
                <div class="down_data_other">
                  <div class="down_data_other_left">
                      <span class="span_style">二氧化碳</span>
                      <span class="span_style_rig">PPM</span>
                      <span class="span_style_value">{{coValue}}</span>
                      <span class="span_style_down">{{coValuestr}}</span>
                      <img class="divtit_img" src="../../../static/img/icon/kulian.png" />




                  </div>
                  <div class="down_data_other_right">
                      <span class="span_style">甲醛</span>
                      <span class="span_style_rig">mg/m²</span>
                      <span class="span_style_value">---</span>

                  </div>

                </div>
            </div>
            <div class="down_expter">
              <h2 class="div_title3">远程操作设置</h2>
              <div class="down_expter_text">
                   <!-- <img id="fengshan" src="../../../static/img/icon/fengji_clase.png" /> -->

              </div>
              <div class="down_expter_item">
                
                  <img id="fengshan" :class="{'active':isActivefj}" src="../../../static/img/icon/icon_move.png" />
                  <span class="fengji_span">{{fjstatus}}</span>

                  <img id="ziwaixian" :class="{'active':isActivezwx}" src="../../../static/img/icon/ziwaixian2.png" /> 
                  <span class="ziwaixian_span">{{xsdstatus}}</span>
                  
                  <img id="device" src="../../../static/img/icon/devoffline.png" /> 
                  <span class="device_span">{{devstatus}}</span>
 
                <div class="button_style">
 
                    <Button class="button_fengji" type="success" icon="ios-shuffle" @click="fengjiOpen" :loading="fjloading" :disabled="fjdisabled">
                        <span v-if="!fjloading">{{fjstatusexp}}</span>
                        <span v-else>执行中...</span>
                    </Button>
                </div>
 
                <div class="button_style1">
                   <Select v-model="modal2" clearable style="width:49%" placeholder="是否定时开启" @on-change="dshandleChange" :disabled="dsdisabled">

                      <Option v-for="(item,index) in isbollList" :value="item.value" :key="index">{{ item.label }}</Option>
 
                  </Select>
                  <Date-picker type="date" v-model="modal3" confirm placeholder="选择开启紫外线日期" style="width: 49%" :disabled="dpdisabled" @on-change="dphandleChange"></Date-picker>
                  <!-- <Date-picker type="datetime" placeholder="请选择消杀日期和时间" style="width:100%" :disabled="dpdisabled" @on-change="handleChange"></Date-picker> -->
                  <Select v-model="modal1" style="width:49%" placeholder="请选择消杀时长" @on-change="handleChange2" :disabled="zwxdisabled">
                      <Option v-for="(item,index) in cityList" :value="item.value" :key="index">{{ item.label }}</Option>
                  </Select>
                  <Time-picker type="time" v-model="model4" confirm placeholder="选择开启紫外线时间" style="width: 49%" :disabled="tpdisabled" @on-change="tphandleChange"></Time-picker>
                  <Button class="button_xiaosha" type="success" icon="ios-sunny" @click="toLoading2" :loading="zwxloading" :disabled="xsddisabled">
                    <span v-if="!zwxloading">{{xsdstatusexp}}</span>
                    <span v-else>执行中...</span>
                  </Button>
                </div>
              </div>
             </div>
      </div>
    </div>
  </div>
  
</template>


<script>
import { mapState } from "vuex";
import EChart from "echarts";
import dataUrl from "../../libs/js/interfaceAddress.js";

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    dialogInfoData: {
      type: Object,
      default: () => {},
    },
    productType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      info_data: "",
      chartLineDom:{
              option: {},
              chart: null,
              element: {},

     },
     cityList: [
                    {
                        value: '15',
                        label: '15分钟'
                    },
                    {
                        value: '30',
                        label: '30分钟'
                    },
                    {
                        value: '60',
                        label: '60分钟'
                    },
                    {
                        value: '90',
                        label: '90分钟'
                    },
                    {
                        value: '120',
                        label: '120分钟'
                    },
                    {
                        value: '240',
                        label: '240分钟'
                    },
                    {
                        value: '255',
                        label: '消杀常开'
                    }
              ],
      isbollList:[{
                        value: '1',
                        label: '预约开启'
                  },
                  {
                        value: '2',
                        label: '每日开启'
                  },],
     deviceInfo:[],
     toploading:false,
     loading: false,
     fjloading:false,
     zwxloading:false,

     fjdisabled:false,
     zwxdisabled:false,
     xsddisabled:false,

     dsdisabled:false,
     dpdisabled:true,
     tpdisabled:true,

     modal1: '30',
     modal2: '',
     modal3:'',
     model4:'',
     fjstatus:'状态未知',
     xsdstatus:'状态未知',
     devstatus:'状态未知',

     fjstatusexp:'未知',
     xsdstatusexp:'未知',
     devstatusexp:'未知',

     isActivefj:false,
     isActivezwx:false,
     tempvalue:0,
     shiduvalue:0,
     coValue:0,
     imeID:'',
     coValuestr:'---',
     datatime:'',
     time:'',
     minutesele:'30',
     redio_item:'',
     timing_set:[],
     };
  },
  components: {

  },
  computed: {
    ...mapState(["onMessageArrived"]),
  },
  created() {
  },
  mounted() {
  
  },
  watch: {
     onMessageArrived: {
      handler(newVal, oldVal) {
         var newInfo = typeof newVal == "string" ? JSON.parse(newVal) : newVal;
        this.pullMessage(newInfo);
      },
      deep: true,
    },
    dialogInfoData: {
      handler: function (newVal, oldVal) {
        // console.log('消杀数据显示-=-=-=-='+JSON.stringify(newVal))
        this.imeID = this.dialogInfoData.imei
         this.pageInit();
      },
      deep: true,
    },
    showDialog:{
      handler:function(newVal,oldVal){
          this.imeID = this.dialogInfoData.imei
          if(newVal){
                 this.initView();
                 this.getdeviceInfo(1);
          }else{
              if(newVal){
              this.$http.get(`${dataUrl.interfaceAddress.emqco2}${this.imeID}`, {}).then((res) => {
                  console.log("关闭页面获取的标记点", res.data.data);
              })
              .catch((err) => {
                  console.log(err);
              });
              }else
              {
                this.setdataConfig();
              }
             
          }
      },
    }
  },
  methods: {
    setdataConfig(){
    this.deviceInfo=[];
    this.loading=false;
     this.fjloading=false;
     this.zwxloading=false;

     this.fjdisabled=false;
     this.zwxdisabled=false;
     this.xsddisabled=false;

     this.dsdisabled=false;
     this.dpdisabled=true;
     this.tpdisabled=true;

     this.modal1='30';
     this.modal2='';
     this.modal3='';
     this.model4='';
     this.fjstatus='状态未知';
     this.xsdstatus='状态未知';
     this.devstatus='状态未知';

     this.fjstatusexp='未知';
     this.xsdstatusexp='未知';
     this.devstatusexp='未知';

     this.isActivefj=false;
     this.isActivezwx=false;
     this.tempvalue=0;
     this.shiduvalue=0;
     this.coValue=0;
     this.imeID='';
     this.coValuestr='---';
     this.datatime='';
     this.time='';
     this.minutesele='30';
     this.redio_item='';
     this.timing_set=[];
    },
     menuSelect(name){
      console.log('选项卡--------'+name);
      if(name=='2'){
        this.toploading=true;
         this.$http.get(`${dataUrl.interfaceAddress.CO2Line}${this.imeID}`, {})
        .then((res) => {
          console.log("setCOlineOption曲线获取的数据", res.data.data);
          this.toploading=false;

          this.setCOlineOption(res.data.data);

        })
        .catch((err) => {
          console.log(err);
          // reject(err)
        });

      }else
      {
        this.setuvKillerLine();
      }
    },
    
     toLoading2() {
        var params;
       this.zwxloading = true;
        if(this.redio_item!='' && typeof this.redio_item!='undefined'){
          if(this.minutesele=='255'){

              this.zwxloading = false;
              this.xsdstatusexp='预约消杀不能常开！'

               setTimeout(()=>{
              this.xsdstatusexp='预开启配置'
              },3000)
              return;
          }
          if(this.time==''){
              this.zwxloading = false;
              this.xsdstatusexp='请选择消杀日期及时间！'
               setTimeout(()=>{
              this.xsdstatusexp='预开启配置'
              },3000)
              return;
          }
            if(this.redio_item=='1'){
              var timestr = this.datatime+" "+this.time;            
              params = {
                    //正式
                    imeiId: this.imeID,
                    type:'1',
                    duration:this.minutesele,
                    timestamp:timestr,
              }
            }
            else if(this.redio_item=='2'){
               params = {
                    //正式
                    imeiId: this.imeID,
                    type:'2',
                    duration:this.minutesele,
                    timestamp:this.time,
              }
            }
          console.log('消杀开关执行事件-=-=-=预开启配置-=-=-=-'+ JSON.stringify(this.redio_item))
          this.$http.post(dataUrl.interfaceAddress.timingSet,params).then((res) => {
            console.log("紫外线定时开启timingSet获取的标记点", res.data);
            if(res.data.code==1){
              this.zwxloading = false;
              this.xsdstatusexp='执行成功'
               setTimeout(()=>{
              this.xsdstatusexp='预开启配置'
              },3000)
              this.getdeviceInfo(0);

            }
          })
          .catch((err) => {
          console.log(err);
          });
          return;
        }
        else
        {

        if(this.isActivezwx){
          params = {
                    //正式
                    imeiId: this.imeID,
                    status: 0,
                    duration:0,
          }
        }
        else
        {
          params = {
                    //正式
                    imeiId: this.imeID,
                    status: 1,
                    duration:this.minutesele,
          }
        }
        console.log('消杀开关执行事件-=-=-=-消杀开关=-=-=-'+ JSON.stringify(params))
        this.$http.post(dataUrl.interfaceAddress.sendlamp,params).then((res) => {
          console.log("紫外线开关sendlamp获取的标记点", res.data.data);
          if(res.data.code!=1){
              this.zwxloading = false;
              this.xsdstatusexp='执行失败，请重试'
               setTimeout(()=>{
                 if(this.isActivezwx){
                  this.xsdstatusexp='紫外线关闭'
                 }else
                 {
                  this.xsdstatusexp='紫外线开启'
                 }
              },3000)
          }
              

        })
        .catch((err) => {
          console.log(err);
         });
        }
      

       
     },
     dphandleChange(date){
          console.log('日期选择器-=-=-=-'+date);
          this.datatime = date;
          if(date!='')
          {
             this.xsdstatusexp = '预开启配置'
          }
          else
          {
            this.xsdstatusexp = '紫外线开启'
 
          }
     },
     tphandleChange(date){
          console.log('时间选择器-=-=-=-'+date);
          this.time = date;
     },
     dshandleChange(date){
         console.log('定时开启选择器-=-=-=-'+date);
         this.redio_item = date;
         if(this.redio_item=='2'){
           this.dpdisabled = true;
           this.tpdisabled = false;
           this.modal3='';
         }
         else
         {
           this.dpdisabled = false;
           this.tpdisabled = false;

         }
           if((date==''||typeof date==='undefined'))
          {
           this.dpdisabled = true;
           this.tpdisabled = true;
           this.modal3='';
           this.model4='';
           if(this.isActivezwx){
              this.xsdstatusexp = '紫外线关闭'
              this.zwxdisabled = true;


           }
           else
           {
              this.xsdstatusexp = '紫外线开启'

           }

 
          }
          else
          {
             this.xsdstatusexp = '预开启配置'
            //  this.dpdisabled = false;
            //   this.tpdisabled = false;
              this.zwxdisabled = false;


          }

     },
     handleChange2(date){
          console.log('分钟选择器-=-=-=-'+date);        
          this.minutesele = date;
           if(this.minutesele==''||typeof this.minutesele==='undefined')
          {
            console.log('紫外线开启0-=-=-=-=-');
            this.xsddisabled = true;
            return;
          }
          else
          {
            this.xsddisabled = false;
          }
     },
    
  
    closeDialog() {
      this.$emit("closeDialog");
     },
    fengjiOpen(){
        this.fjloading=true;
        if(this.isActivefj){
          let params = {
                    //正式
                    imeiId: this.imeID,
                    status: 0,
          }
          this.$http.post(dataUrl.interfaceAddress.fanDriver,params).then((res) => {
          console.log("风机关闭获取的标记点", res.data.data);

        })
        .catch((err) => {
          console.log(err);
          // reject(err)
        });
        }
        else
        {
          let params = {
                     imeiId: this.imeID,
                    status: 1,
          }
          this.$http.post(dataUrl.interfaceAddress.fanDriver,params).then((res) => {
          console.log("风机开启获取的标记点", res.data.data);
         })
        .catch((err) => {
          console.log(err);
          // reject(err)
        });
        }

    },
    pageInit() {
      this.info_data = this.$deepClone(this.dialogInfoData);

    },
    getdeviceInfo(type){
    this.deviceInfo = [];
    this.$http.get(`${dataUrl.interfaceAddress.getdeviceInfo}${this.imeID}`, {})
        .then((res) => {
          console.log("获取的标记点", res.data.data);
          
          this.deviceInfo.push({
      　　  'value':'客户名称：'+res.data.data.customer_name,
     　　 },{
      　　  'value':'管辖区域名称：'+res.data.data.mgmt_area_name,
          },{
      　　  'value':'地址：'+res.data.data.position,
          },{
      　　  'value':'紫外线消杀累计时长：'+res.data.data.total_time,
          },{
      　　  'value':'紫外线消杀剩余时长：'+res.data.data.time_remain,
          });
          
        
          this.tempvalue = res.data.data.temperature;
          this.shiduvalue = res.data.data.humidity;
          this.timing_set = res.data.data.timing_set.split(',');
          this.setTimeConfig();
          if(type==1){
            this.setStatusConfing(res.data.data);
          }
         

 

        })
        .catch((err) => {
          console.log(err);
          // reject(err)
        });
    },
    setStatusConfing(data){
          this.ziwaixianexper(data.lamp_status);
          this.fengjiexper(data.fan_status);
          this.setdeviceStates(data.is_offline);
          this.setCo2Value(data.co2);
    },
    fengjiexper(isbool){
       this.fjloading=false;
      if(isbool=='1'){
            this.fjstatus = '风机开起'
            this.fjstatusexp = '风机关闭'
            this.isActivefj=true
           
      }else if(isbool=='0')
      {
            this.fjstatus = '风机关闭'
            this.fjstatusexp = '风机开启'
            this.isActivefj=false
      }else
      {
            // this.fjdisabled = true;
      }

    },
    setdeviceStates(status){
      if(status=='0'){
        this.devstatus='设备在线'
        $("#device").attr('src','../../../static/img/icon/devonline.png'); 


      }
      else if(status=='1'){
        this.devstatus='设备离线'
        $("#device").attr('src','../../../static/img/icon/devoffline.png'); 
      }
      else
      {
        this.devstatus='状态未知'
        $("#device").attr('src','../../../static/img/icon/devoffline.png'); 
      }
    },  
    ziwaixianexper(isbool){
      console.log('消杀灯回执状态-=-=-=-=-=-=-'+JSON.stringify(isbool))
      this.zwxloading=false;
      if(isbool=='1'){
            this.xsdstatus = '紫外线开启'
            this.xsdstatusexp = '紫外线关闭'
            this.modal2 = ''
            this.isActivezwx=true
            this.dpdisabled = true;
            this.zwxdisabled = true;
            this.dsdisabled = false;

           this.modal3='';
           this.model4='';
           this.tpdisabled = true;
           
      }else if(isbool=='0')
      {
            this.xsdstatus = '紫外线关闭'
            this.xsdstatusexp = '紫外线开启'
            this.isActivezwx=false;
             this.dpdisabled = true;
            this.zwxdisabled = false;
            this.dsdisabled = false;
            this.tpdisabled=true;


      }
      else
      {
            this.zwxdisabled=true;
            this.xsddisabled=true;
      }
    }, 
    setCo2Value(value){
       this.coValue =value; 
       if(this.coValue<700){
          this.coValuestr = '健康的室外空气'
       }
        else
       {
          this.coValuestr = '空气混浊，对健康不利'
       }
    }, 
    setTimeConfig(){

       var num1 = this.timing_set[1];
       var num2 = this.timing_set[0];
       var num3 = this.timing_set[2];
       console.log('setTimeConfig-=-=-=-=--=-=-=-'+JSON.stringify(num1))

       if(num1=='1'){
          this.deviceInfo.push({
      　　  'value':'紫外线预开启模式：预约开启',
     　　 },{
      　　  'value':'紫外线预开启时间：'+num2,
     　　 },{
      　　  'value':'紫外线预开启时长：'+num3+' 分钟',
     　　 });  
         
       }
       else{
            this.deviceInfo.push({
      　　  'value':'紫外线预开启模式：每日开启',
     　　 },{
      　　  'value':'紫外线预开启时间：'+num2,
     　　 },{
      　　  'value':'紫外线预开启时长：'+num3+' 分钟',
     　　 });  
       }

    },
    setSterilizationLine(data){
       var uvdataarray=[];
       var nmdataarray=[];
       var timearray=[];

        for(var item in data.uv){
             uvdataarray.push(data.uv[item]);
         }
          for(var item in data.nm){
             nmdataarray.push(data.nm[item]);
         }
         for(var i=0;i<data.uv.length;i++){
             timearray.push(i+"分");
         }
    console.log('uvdataarray数据展示-=-=-'+JSON.stringify(uvdataarray)+'-=-=-nmdataarray数据存储时间=-=-'+JSON.stringify(timearray))
   

setTimeout(() => {
 
        // 指定图表的配置项和数据
        this.chartLineDom.option = {
        title: {
            text: '消杀效果曲线图',
            textStyle:{
                color:'#65c6e7',
            }
            }    
        ,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
            type: 'cross',
                label: {
                    backgroundColor: '#2E9AFE'
                }
            }
        },
        legend: {
            data: ['UVC消杀灯未启动时', 'UVC消杀灯启动时'],
            textStyle:{
                color:'#00CCFF',

            }
         },
        toolbox: {
            feature: {
                // saveAsImage: {}
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: 
            {
                type: 'category',
                boundaryGap: false,
                data: timearray,
                lineStyle:{
                    shadowColor: 'rgba(14, 125, 36,1)',
                    shadowBlur: 10
                } ,
                 nameTextStyle:{
                     backgroundColor:'red'
                 },
                 axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#00CCFF', //X轴文字颜色
                                fontSize: 12
                            }
                 },
                axisLine: {
                            lineStyle: {
                                color: '#00CCFF'
                            }
                },
                 itemStyle : {
                        normal : {
                           color:'#65c6e7'
                },
           
                }

            },
           
        yAxis: 
            {
                type: 'value',
                 axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#00CCFF',
                                // fontSize: 14,  //大
                                fontSize: 15
                            }
                },
                 axisLine: {
                            lineStyle: {
                                color: '#00CCFF'
                            }
                },
                 nameTextStyle: {
                      color: '#63c6e6',
                      fontSize: 12
                },
                  splitLine: {
                    show: true,
                lineStyle:{
                  color: ['#003b8b'],
                  width: 1,
                  type: 'solid'
                  }
                }   


            },
        series: [
            {
                name: 'UVC消杀灯未启动时',
                type: 'line',
                stack: '总量',
                areaStyle: {
                  color:'#2E64FE',
                },
                 emphasis: {
                    focus: 'series'
                  },
                itemStyle: {
				          normal: {
					          color: '#2E64FE', //改变折线点的颜色
					        lineStyle: {
						        color: '#2E64FE' //改变折线颜色
				        	}
			        	}
			          },
                data: uvdataarray
            },
            {
                name: 'UVC消杀灯启动时',
                type: 'line',
                stack: '总量',
                areaStyle: {},
                label: {
                  normal: {
                    show: true,
                    position: 'top'
                  }
                },
                 emphasis: {
                    focus: 'series'
                  },
                 itemStyle: {
                        normal: {
                            color: '#8000FF',  // 会设置点和线的颜色，所以需要下面定制 line
                            shadowColor: '#8cd5c2',  // 点边线的颜色
                            shadowBlur: 10 ,    // 点边线的阴影
                        }
                    },
                data:nmdataarray
            },
          
    ]
};
          console.log('-=-=-=-=-=-=-chart存在数据-=-=-=-=-')

        // 使用刚指定的配置项和数据显示图表。
        if(this.chartLineDom.chart!=null){
          this.chartLineDom.chart.dispose();
        }
                this.chartLineDom.chart = EChart.init(this.$refs.chartLineDom)
                this.chartLineDom.chart.setOption(this.chartLineDom.option)
      }, 1);
    },
    setuvKillerLine(){
       this.toploading=true;
        console.log('消杀数据imei号码-=-=asd-=-'+JSON.stringify(this.imeID))
       this.$http.get(`${dataUrl.interfaceAddress.sterilizationLine}${this.imeID}`, {})
        .then((res) => {
          console.log("setCOlineOption消杀曲线获取的数据", res.data.data);
          this.toploading=false;
          this.setSterilizationLine(res.data.data);
          
        })
        .catch((err) => {
          console.log(err);
          // reject(err)
        });



    },
    setCOlineOption(data){
        // console.log('数据展示-=-=-'+JSON.stringify(data.data.data)+'-=-=-数据存储时间=-=-'+JSON.stringify(data.time))
        var dataarray=[];
        var timearray=[];
         for(var item in data.data){
             dataarray.push(data.data[item]);
         }
          for(var item in data.time){
             timearray.push(data.time[item]);
         }
         

         setTimeout(() => {
 
        // 指定图表的配置项和数据
        this.chartLineDom.option = {
        title: {
            text: '二氧化碳曲线图',
            textStyle:{
                color:'#65c6e7',
            }
            }    
        ,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
            type: 'cross',
                label: {
                    backgroundColor: '#2E9AFE'
                }
            }
        },
        legend: {
            data: ['二氧化碳浓度值'],
            textStyle:{
                color:'#00CCFF',

            }
         },
        toolbox: {
            feature: {
                // saveAsImage: {}
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: 
            {
                type: 'category',
                boundaryGap: false,
                data:timearray,
                lineStyle:{
                    shadowColor: 'rgba(14, 125, 36,1)',
                    shadowBlur: 10
                } ,
                 nameTextStyle:{
                     backgroundColor:'red'
                 },
                 axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#00CCFF', //X轴文字颜色
                                fontSize: 12
                            }
                 },
                axisLine: {
                            lineStyle: {
                                color: '#00CCFF'
                            }
                },
                 itemStyle : {
                        normal : {
                           color:'#65c6e7'
                },
           
                }

            },
           
        yAxis: 
            {
                type: 'value',
                 axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#00CCFF',
                                // fontSize: 14,  //大
                                fontSize: 15
                            }
                },
                 axisLine: {
                            lineStyle: {
                                color: '#00CCFF'
                            }
                },
                 nameTextStyle: {
                      color: '#63c6e6',
                      fontSize: 12
                },
                  splitLine: {
                    show: true,
                lineStyle:{
                  color: ['#003b8b'],
                  width: 1,
                  type: 'solid'
                  }
                }   


            },
        series: [
            {
                name: '二氧化碳浓度值',
                type: 'line',
                stack: '总量',
                areaStyle: {
                  color:'#2E64FE',
                },
                 emphasis: {
                    focus: 'series'
                  },
                itemStyle: {
				          normal: {
					          color: '#2E64FE', //改变折线点的颜色
					        lineStyle: {
						        color: '#2E64FE' //改变折线颜色
				        	}
			        	}
			          },
                data:dataarray,
            },
           
          
    ]
};
          console.log('-=-=-=-=-=-=-chart存在数据-=-=-=-=-')

        // 使用刚指定的配置项和数据显示图表。
        if(this.chartLineDom.chart!=null){
          this.chartLineDom.chart.dispose();
        }
                this.chartLineDom.chart = EChart.init(this.$refs.chartLineDom)
                this.chartLineDom.chart.setOption(this.chartLineDom.option)
      }, 1);



    },
    initView() {
       
       this.setuvKillerLine();

    },
    pullMessage(newInfo) {

    // console.log(
    //     "消杀数据推过来了" + newInfo + "type" + newInfo.action
    //   );

      if(newInfo.deviceCategory=='uvKiller'){
         if(newInfo.imeiId==this.imeID){
           if(newInfo.data.status=='uvFanStatus'){
                    this.fengjiexper(newInfo.data.reportList.uvFanStatus);
           }
           else if(newInfo.data.status=='uvLampStatus'){
             console.log('消杀model2状态-=-=uvLampStatus-=-='+ JSON.stringify(this.modal2))
                  //  if(this.modal2==''||typeof this.modal2==='undefined'){
                      this.ziwaixianexper(newInfo.data.reportList.uvLampStatus);
                  //  }

           }
           else if(newInfo.data.status=='uvco2Date'){
            this.setCo2Value(parseInt(newInfo.data.reportList.co2));

           }
            else if(newInfo.data.status=='uvdeviceStatus'){
            this.fengjiexper(newInfo.data.reportList.uvFanStatus);
              console.log('消杀model2状态-=-=uvdeviceStatus-=-='+ JSON.stringify(this.modal2))
            // if(this.modal2==''||typeof this.modal2==='undefined'){
            this.ziwaixianexper(newInfo.data.reportList.uvLampStatus);
            // }
            this.setCo2Value(parseInt(newInfo.data.reportList.co2));

           }


         }
         
      }

    
    }
    
  },
};
</script>
<style lang="less" scoped>

.dialog {
  .dialog_mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    z-index: 10;
  }

  .container {
    width: 100%;
    height: 105%;
    position: fixed;
    top: -5%;
    left: 0px;
    right: 0px;
    margin-left: auto;
    margin-right: auto;
    z-index: 10;
    // background:url(../../../static/img/er_bg.png) no-repeat;
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/er_bg.png)
      no-repeat;
    background-position: 100% 100%;
    background-size: 100% 95%;
    z-index: 11;
    .close {
      width: 35px;
      height: 35px;
      cursor: pointer;
      position: relative;
      margin-left: 97%;
      top: 6.5%;
      // margin-bottom: 10px;
      // height: 20px;
      // background: url(../../../static/img/close.png) no-repeat;
      background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/close.png)
        no-repeat;
      background-size: 100% 100%;
      z-index: 10;
    }
    .title {
      // background: url(../../../static/img/er_title.png);
      // background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/er_title.png) no-repeat;
      // background-size: 100% 100%;
      color: #fefefe;
      font-size: 25px;
      position: absolute;
      top: 6%;
      text-align: center;
      width: 100%;

      .close_alarm_style {
        width: 32%;
        text-align: right;
        line-height: 3;
        margin-left: 800px;
        color: red;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .content {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      // background:url(../../../static/img/er_bg.png) no-repeat;
      // background-position: 100% 100%;
      padding-top: 45px;
      .content_left {
        width: 25%;
        height: 560px;
        float: left;
        padding-top: 15px;
      }
      .content_center {
        width: 50%;
        height: 560px;
        // background:yellow;
        float: left;
      }
      .content_right {
        width: 25%;
        height: 560px;
        // background:red;
        float: right;
        padding-top: 15px;
      }
    }
  }
  .dialog_tabs {
    position: absolute;
    top: 12%;
    left: 0px;
    right: 0px;
    height: 120px;
    .el-tabs__header.is-top {
      margin-bottom: 40px;
      color: red;
    }
  }

  .line_item {
    position: absolute;
    // background-color: #A9D0F5;
    top: 20%;
    height:40%;
    width:100%;
    left: 10px;
    right: 10px;
    opacity: 1;

    // background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/right.png) no-repeat;
    // background-size: 100% 100%;
    // margin-right:18px;
    .element_loading{
      z-index:999;
      position: relative;
      text-align: center;
      top: 0%;
      background-color: rgba(0, 0, 0, 0.301);
      width: 100%;
      height: 100%;
    }
 
  }
  .down_center{
    position: absolute;
    top: 62%;
    left: 10px;
    right: 10px;
    // height: 30%;
    bottom: 10px;
    // background-color: chartreuse;
  }
  .down_info{
    position: relative;
    float: left;
    top: 10px;
    left: 0%;
    width: 33%;
    height: 95%;

    // background-color: #A9D0F5;

    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/right.png) no-repeat;
    background-size: 100% 100%;
    .div_title1{
      position: relative;
      float: right;
      right:12%;
      top: -5px;
    font-size: 20px;
    line-height: 20px;
    color: #17c4e4;
    font-weight: bold;
    text-align: center;
    margin-left: 10px;
    display: block;
      
      // background-color: crimson;
      
    }
    .down_li_item{
      position: absolute;
      top:10%;
      left: 2%;
      right: 2%;
      bottom:3%;
      color: rgb(255, 241, 220);
      text-align:center;
      // background-color: tomato;
      background-color:rgba(17, 194, 238, 0.3);
      box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
      padding: 3%;
      border-collapse:separate;
      .text_item{
        position: relative;
        top: 0%;
        bottom: 10%;
      };
      // overflow:auto;

    }
    .ol1{
      line-height:28px;
      font-size:13px;
      text-align: left;
      // display: table;

      left:10px;
      right:0%;
      top:0%;
      bottom:0%;
      margin:auto;
      // background-color: yellow;
    }

  }
  .down_data{
    position: relative;
     float: left;
    top: 10px;
    left: 1%;
    width: 33%;
    height: 96%;
    // background-color: red;
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/right.png) no-repeat;
    background-size: 100% 100%;
    .div_title2{
     position: relative;
      float: right;
    

        right:12%;
      top: -5px;
      font-size: 20px;
    line-height: 20px;
    color: #17c4e4;
    font-weight: bold;
    text-align: center;
    margin-left: 10px;
    display: block;
  }
  
.down_data_shidu{
    position: absolute;
    top: 10%;
    width: 47.5%;
    height: 40%;
    background-color: thistle;
    text-align:center;
  
    margin:0 auto; 
    display: flex;
    justify-content: center;
    align-items: center;


    background-color:rgba(17, 194, 238, 0.3);
    right: 2%;
    box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);



    .divtit_img{
    position: relative;
    float: left;
    width: 25px;
    height: 25px;
    left: -2px;
    }
    .span_key{
    position: relative;
    float: left;
   color: white;
    font-size: 30px;
    font-family:dateTime;
    }
    }
    .down_data_temp{
    position: absolute;
    // float: left;
    top: 10%;
    width: 47.5%;
    height: 40%;
    // background-color: tomato;
    left: 2%;
    text-align:center;
  
    margin:0 auto; 
    display: flex;
    justify-content: center;
    align-items: center;


    background-color:rgba(17, 194, 238, 0.3);
    box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);

  .divtit_img{
    position: relative;
    float: left;
    width: 25px;
    height: 25px;
    left: -2px;
    }
    .span_key{
    position: relative;
    float: left;
    color: white;
    font-size: 30px;
    // font-family:"Liquid Crystal";
    font-family: dateTime;
 
    }

    }
     
    .down_data_other{
        // position: relative;
        // //  float: left;
        // background-color: yellow;
        // left: 0%;
        // right: 0%;
        // top: 10%;
        // // height: 50%;
        // bottom: 0%;
 

    position: absolute;
    bottom: 0%;
    width: 100%;
    height: 50%;
    // background-color: yellow;
    // text-align:center;
  
    margin:0 auto; 
    display: flex;
    justify-content: center;
    align-items: center;
    .down_data_other_left{
    position: absolute;
    bottom: 7%;
    width: 47.5%;
    height: 92%;
    background-color:rgba(17, 194, 238, 0.3);
    left: 2%;
    // box-shadow: 2px 2px 5px #909090;
    box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
    .divtit_img{
    position: absolute;
    width: 20px;
    height: 20px;
    left: 15%;
    bottom: 35%;

    }
    .span_style_down{
    position: absolute;
    bottom: 10%;
    color: white;
    text-align:center;
    left: 0%;
    right: 0%;
    font-size: 12px;
    font-family:dateTime;

    }

    }
    .down_data_other_right{
    position: absolute;
    bottom: 7%;
    width: 47.5%;
    height: 92%;
    background-color:rgba(17, 194, 238, 0.3);
    right: 2%;
 
    // box-shadow: 2px 2px 5px #909090;
    box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);


		}
 
    .span_style{
    position: absolute;
    top: 10px;
    color: white;
    left: 10px;

    }
    .span_style_rig{
    position: absolute;
    top: 10px;
    color: white;
    right: 10px;
    }
    .span_style_value{

  position: absolute;
    top: 40%;
    color: white;
    text-align:center;
    left: 0%;
    right: 0%;
    font-size: 35px;
    font-family:dateTime;

    }

    }
  
 }
  .down_expter{
    position: relative;
    float: left;
    top: 10px;
    left: 2%;
    width: 32%;
    height: 96%;
  //  background-color: blueviolet;
      background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/right.png) no-repeat;
    background-size: 100% 100%;
    .div_title3{
      position: relative;
      float: right;
      right:12%;
      top: -5px;
      font-size: 20px;
    line-height: 20px;
    color: #17c4e4;
    font-weight: bold;
    text-align: center;
    margin-left: 10px;
    display: block;
      
    }
    .down_expter_text{
      position: absolute;
      top: 10%;
      left: 2%;
      text-align:center;
      // background-color: cadetblue;
      width: 96%;
      bottom: 3.5%;
                // background-color:rgba(17, 194, 238, 0.3);
                

    }
    .down_expter_item{
      position: absolute;
        // text-align:center;
        // float: right;
      // background-color: blueviolet;
      width: 100%;
      height: 86%;
      top: 10%;
      right: 0%;
      // left: 0%;
    .button_style{
      position: absolute;
       left: 10%;
       top: 35%;
       width: 80%;
      height: 40px;
        //  align-items: center;
      .button_fengji{
        position: relative;
        top:4%;
        width:100%;
        height:40px;


      }
    }
    // .button_style2{
    //   position: absolute;
    //    top: 24%;
    //   left: 10%;
    //    width: 80%;
    //   height: 40px;
    // }
    .button_style1{
      position: absolute;
       top: 55%;
      left: 10%;
       width: 80%;
      height: 50%;
      // background-color: crimson;
      //  background-color:rgba(17, 194, 238, 0.3);

      .button_xiaosha{
        position: relative;
        top:4%;
        width:100%;
        height:40px;

      }
    }

    }
    
@keyframes rotateImg {
  0% {transform : rotate(0deg);}
  100% {transform : rotate(360deg);}
}

@-webkit-keyframes rotateImg {
    0%{-webkit-transform : rotate(0deg);}
  100%{-webkit-transform : rotate(360deg);}
}
    .active{

      -webkit-animation:rotateImg 1s linear infinite;

    }
    #fengshan{
      position: relative;
      width: 32px;
      height: 32px;
      left: 12%;
      top: 3%;
    }
    #ziwaixian{
      position: relative;
      width: 32px;
      height: 32px;
      // float: left;

      left: 40%;
      top: 3%;
      // -webkit-animation:rotateImg 1s linear infinite;
    }
    #device{
       position: absolute;
      width: 32px;
      height: 32px;
      // float: left;
      right: 12%;
      top: 3%;
            // -webkit-animation:rotateImg 1s linear infinite;
    }
    .fengji_span{
      position: absolute;
      left:10%;color:cornsilk;
      top: 15%;
   
        
    }
   
    .ziwaixian_span{
      position: absolute;
      left:43%;color:cornsilk;
      top: 15%;

    }
    
    .device_span{
      position: absolute;
      right:11%;color:cornsilk;  
      top: 15%;

    }
    #xiaosha{
      position: relative;
      width: 32px;
      height: 32px;
      float: left;
      left: 30%;
      top: 17%;

    }
  }

 
}
</style>




// WEBPACK FOOTER //
// src/components/dialog/dialog_click_win.vue